import QRCodeStyling, { Options } from "qr-code-styling";
import React from "react";

const BtnUseGuide = (props: IProps) => {
  const refQrCode = React.useRef(null);

  const [options, setOptions] = React.useState<Options>({
    width: 43,
    height: 43,
    margin: 0,
    data: "",
    qrOptions: {
      mode: "Byte",
      errorCorrectionLevel: "H"
    },
    dotsOptions: { type: "square", color: "#000000" },
    backgroundOptions: { color: "#ffffff" },
    cornersDotOptions: {
      type: "dot"
    },
    cornersSquareOptions: {
      type: "square"
    },
  })

  const [qrCode] = React.useState<QRCodeStyling>(new QRCodeStyling(options));

  React.useEffect(() => {
    if (refQrCode.current) {
      qrCode.append(refQrCode.current);
    }
  }, [qrCode]);

  React.useEffect(() => {
    if (!qrCode) return;
    qrCode.update(options);
  }, [qrCode, options]);

  React.useEffect(() => {
    setOptions(options => ({
      ...options,
      data: props.url,
    }));
  }, [props.url])

  return <div className="lucky-wheel-button qr-button">
    <div className="qr-code-wrapper"><div ref={refQrCode} className="qr-code"></div></div>
    <span>Thể lệ chương trình</span>
  </div>
}

export default BtnUseGuide;

interface IProps {
  url?: string
}